module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "contact_hero.1fb97580.jpg";